import React from "react";
import { SendResponsesModal } from "../../../SendResponsesModal";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const SendResponsesModalWrapper: React.FC = () => {
  const { selection, modals } = useClarificationsRegisterContext();
  const { selectedItemsForSending } = selection;
  const { isSendResponsesModalOpen, setIsSendResponsesModalOpen, isSendingResponses, handleConfirmSend } = modals;

  return (
    <SendResponsesModal
      isOpen={isSendResponsesModalOpen}
      onClose={() => setIsSendResponsesModalOpen(false)}
      onConfirm={handleConfirmSend}
      clarifications={selectedItemsForSending}
      isLoading={isSendingResponses}
    />
  );
};
